import { onINP, onCLS } from 'web-vitals/attribution'
import * as Sentry from '@sentry/vue'
import { Router } from 'vue-router'
import { getPageVersion } from './getPageVersion'

export const trackWebVitals = (router: Router): void => {
  const metrics = [
    { handler: onINP, name: 'INP' },
    { handler: onCLS, name: 'CLS' },
  ]

  const metricHandler = (metric: any) => handleWebVitals(metric, router)

  metrics.forEach(({ handler, name }) => {
    try {
      handler(metricHandler, { reportAllChanges: true })
    } catch (error) {
      console.error(`[WebVitals] Failed to initialize ${name} tracking:`, error)
    }
  })
}

const handleWebVitals = (metric: any, router: Router) => {
  try {
    const currentRoute = router.currentRoute.value
    if (!currentRoute) {
      console.warn('[WebVitals] Current route not available')
    }

    const routeName = currentRoute.name
    const routePath = currentRoute.path

    if (!routeName || !routePath) {
      console.warn('[WebVitals] Route name or path is missing')
    }

    const pageVersion = getPageVersion(currentRoute.params?.location_id, currentRoute.name)

    // navigationType - 'navigate' | 'reload' | 'back-forward' | 'prerender' | 'restore' | 'back-forward-cache'
    const { attribution, name, navigationType, value, delta, id } = metric || {}
    const {
      interactionTarget,
      interactionType,
      interactionTime,
      inputDelay,
      loadState,
      presentationDelay,
      processingDuration,
      largestShiftTarget,
      largestShiftValue,
    } = attribution || {}

    const commonPayload = {
      webVitalName: name,
      webVitalValue: value,
      webVitalDelta: delta,
      loadState, // loading state of the page - 'loading' | 'dom-interactive' | 'dom-content-loaded' | 'complete'
      interactionId: id,
      navigationType,
      routePath,
      routeName,
    }

    let payload = {}

    if (name === 'CLS') {
      payload = {
        ...commonPayload,
        largestShiftValue,
        largestShiftTarget,
      }
    }

    if (name === 'INP') {
      payload = {
        ...commonPayload,
        eventTarget: interactionTarget,
        type: interactionType,
        interactionTime,
        inputDelay: +inputDelay?.toFixed(2),
        presentationDelay: +presentationDelay?.toFixed(2),
        processingDuration: +processingDuration?.toFixed(2),
      }
    }

    // try {
    //   Sentry.logger.info(`webVitals.${name}`, payload)
    // } catch (logError) {
    //   console.error('[WebVitals] Failed to log to Sentry logger:', logError)
    // }

    try {
      Sentry.metrics.distribution(`webVitals.${name}`, value, {
        unit: 'MB',
        attributes: {
          ...payload,
          ...(pageVersion && { pageVersion }),
        },
      })
    } catch (metricsError) {
      console.error('[MemoryTracking] Failed to send metrics to Sentry:', metricsError)
    }
  } catch (error) {
    console.error('[WebVitals] Failed to handle web vitals:', error)
  }
}
